export default {
  dashboardv2: {
      usersByStatus: "Utilisateurs par statut",
      allTime: "Tout le temps",
      noOfUsers: "Nombre d'utilisateurs",
      usersByGender: "Utilisateurs par genre",
      gender: "Genre",
      farmerName: "Nom de l'agriculteur",
      farmerProduction: "Production de l'agriculteur",
      production: "Production",
      plan: "Plan",
      expiryDate: "Date d'expiration",
      buyingStationProduction: "Production de station d'achat",
      dryMillingProduction: "Production de décorticage à sec",
      usersPerMembershipPlans: "Utilisateurs par plans d'adhésion",
      planType: "Type de plan",
      users: "Utilisateurs",
      planValidity: "Validité des plans",
      averageSellingPriceByAllFarmers: "Prix de vente moyen de tous les agriculteurs",
      avgSellingPrice: "Prix de vente moyen",
      pricePaid: "Prix payé",
      avgSellingPricePerFarmer: "Prix de vente moyen par agriculteur",
      exportAsCSV: "Exporter en CSV",
      exportAsXLS: "Exporter en XLS",
  
      filterByFarm: "Filtrer par fermes",
      searchFarms: "Rechercher des fermes",
      filterByRegion: "Filtrer par région",
      filterByFarmer: "Filtrer par agriculteur",
    },

    dashboardSection: {
      greenBeansData: "Gestion des grains verts",
      dryMilling: "Décorticage à sec",
      modules: "Modules",
      allowances: "Indemnités",
      maxUserAllowed: "Nombre maximum d'utilisateurs autorisés",
      satelliteReportsAllowed: "Rapports satellite autorisés",
      advanceReport: "Rapports avancés autorisés",
      subscriptionUpTo: "Abonnement jusqu'à",
      roleAllowed: "Rôles autorisés",
      moduleAllowed: "Modules autorisés",
      registeredUsers: "Utilisateurs enregistrés",
      validMemberships: "Adhésions valides",
      activeUsers: "Utilisateurs actifs",
      deactivatedUsers: "Utilisateurs désactivés",
      membershipValidity: "Validité de l'adhésion",
      lessThan1Month: "Moins d'un mois",
      months1to6: "1-6 mois",
      months6to12: "6-12 mois",
      moreThan1Year: "Plus d'un an",
      cropOverview: "Aperçu des cultures",
      buySellOverview: "Aperçu des achats/ventes",
      plantations: "Plantations",
      coffeeData: "Données sur le café",
      availableModules: "Modules disponibles",
      roleList: "Agriculteur, station d'achat, entrepôt",
      memberData: "Données des membres",
      userType: "Type d'utilisateur",
      registered: "Enregistré",
      offlineUsers: "Utilisateurs hors ligne",
      lessThanOneMonth: "< 1 mois",
      cacaoData: "Données sur le cacao",
      dryCacao: "Cacao sec",
      traceability: "Traçabilité",
      allFarm: "Toutes les fermes",
    },

    dashboardReports: {
      appDataReports: "Rapports sur les données de l'application",
      reports: "Rapports",
    },
}
